/**
 * Aggregated preliminary charges across all draft jobs. Read-only here —
 * per-line editing lives on the per-device page. On-system styling (skill).
 */

import React from 'react';
import { IconLock } from '@tabler/icons-react';
import type { CheckInSession } from '@techgitter/contracts';

import { Chip } from '../../chip';
import { chargesTotal, formatAud, isChargesLocked } from './sessionDetailHelpers';

export interface CheckInChargesSectionProps {
  session: CheckInSession;
}

export const CheckInChargesSection: React.FC<CheckInChargesSectionProps> = ({ session }) => {
  const locked = isChargesLocked(session);

  return (
    <div className="ci-section">
      {locked && (
        <div className="ci-chips">
          <Chip tone="neutral">
            <IconLock size={12} stroke={1.5} />
            Charges locked — payment accepted
          </Chip>
        </div>
      )}

      {(session.draftJobs ?? []).map((job, jobIdx) => {
        const lines = job.preliminaryCharges ?? [];
        if (lines.length === 0) return null;
        return (
          <div key={job.id}>
            <span className="ci-subhead" style={{ display: 'block', marginBottom: 6 }}>
              Device {jobIdx + 1}: {job.serviceSummary || 'Untitled'}
            </span>
            <div className="ci-section ci-section--tight">
              {lines.map(c => (
                <div className="ci-amount-row" key={c.id}>
                  <span className="ci-amount-row__label">{c.lineItemId || '(no product code)'}</span>
                  <span className="ci-amount-row__value">{formatAud(c.finalTotal || 0)}</span>
                </div>
              ))}
            </div>
          </div>
        );
      })}

      {chargesTotal(session) === 0 && <div className="ci-caption">No charges yet.</div>}
    </div>
  );
};
